// Fecha en letras para las plantillas jurídicas, p. ej.:
//   "tres (03) de julio de dos mil veintiséis (2026)"
// Réplica del formato usado por el backend (ActaRepartoService) para que el
// documento generado en el cliente coincida con el oficial.

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

const UNIDADES = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
const ESPECIALES: Record<number, string> = {
  10: 'diez', 11: 'once', 12: 'doce', 13: 'trece', 14: 'catorce', 15: 'quince',
  16: 'dieciséis', 17: 'diecisiete', 18: 'dieciocho', 19: 'diecinueve',
  20: 'veinte', 21: 'veintiuno', 22: 'veintidós', 23: 'veintitrés', 24: 'veinticuatro',
  25: 'veinticinco', 26: 'veintiséis', 27: 'veintisiete', 28: 'veintiocho', 29: 'veintinueve',
};
const DECENAS = ['', '', '', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];

/** Número 0-99 en palabras (día del mes y sufijo del año). */
function enPalabras(n: number): string {
  if (n < 10) return UNIDADES[n];
  if (n <= 29) return ESPECIALES[n] ?? '';
  const d = Math.floor(n / 10);
  const u = n % 10;
  return u === 0 ? DECENAS[d] : `${DECENAS[d]} y ${UNIDADES[u]}`;
}

/** "tres (03) de julio de dos mil veintiséis (2026)" a partir de un ISO YYYY-MM-DD. */
export function fechaEnLetras(iso: string): string {
  const d = new Date(iso.length <= 10 ? `${iso}T00:00:00` : iso);
  if (isNaN(d.getTime())) return '____________ (__) de __________ de dos mil ______ ()';
  const dia = d.getDate();
  const anio = d.getFullYear();
  const suf = anio - 2000;
  const anioPal = suf <= 0 ? 'dos mil' : `dos mil ${enPalabras(suf)}`;
  return `${enPalabras(dia)} (${String(dia).padStart(2, '0')}) de ${MESES[d.getMonth()]} de ${anioPal} (${anio})`;
}
